import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { PersianNumber } from "@thg303/react-persian";

const AddressesTable = ({ addresses, removeAddress }) => {
  return (
    <Table striped hover>
      <thead>
        <tr>
          <th className="text-right">شماره</th>
          <th className="text-right">آدرس</th>
          <th className="text-right">حذف</th>
        </tr>
      </thead>
      <tbody>
        {addresses?.map((address, index) => (
          <tr key={index} style={{ cursor: "pointer" }}>
            <td>
              <PersianNumber>{index + 1}</PersianNumber>
            </td>
            <td>{address}</td>
            <td>
              <button
                onClick={() => removeAddress(index)}
                style={{
                  border: "none",
                  background: "transparent",
                  color: "red",
                  cursor: "pointer",
                }}
              >
                حذف
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AddressesTable;
